
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/human-handoff",
      function () {
        return require("private-next-pages/docs/human-handoff.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/human-handoff"])
      });
    }
  